var _path, _path2, _path3, _rect, _path4, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconPromotionActive(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.6665 10.6667H25.3332V22.6667C25.3332 24.5523 25.3332 25.4951 24.7474 26.0809C24.1616 26.6667 23.2188 26.6667 21.3332 26.6667H10.6665C8.78089 26.6667 7.83808 26.6667 7.25229 26.0809C6.6665 25.4951 6.6665 24.5523 6.6665 22.6667V10.6667Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.9998 10.6667L15.6809 7.79614C15.4829 6.01454 13.9562 4.66669 12.1636 4.66669V4.66669C10.2449 4.66669 8.6665 6.22208 8.6665 8.14076V8.14076C8.6665 9.30232 9.24702 10.387 10.2135 11.0314L12.6665 12.6667",
    stroke: "url(#paint0_linear_538_14845)",
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.0002 10.6667L16.3191 7.79614C16.5171 6.01454 18.0438 4.66669 19.8364 4.66669V4.66669C21.7551 4.66669 23.3335 6.22208 23.3335 8.14076V8.14076C23.3335 9.30232 22.753 10.387 21.7865 11.0314L19.3335 12.6667",
    stroke: "url(#paint1_linear_538_14845)",
    strokeLinecap: "round"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 5.3335,
    y: 10.6667,
    width: 21.3333,
    height: 4,
    fill: "url(#paint2_linear_538_14845)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M16 14.6667V20",
    stroke: "#222222",
    strokeLinecap: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_538_14845",
    x1: 8.6665,
    y1: 8.66669,
    x2: 15.9998,
    y2: 8.66669,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C7831F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFB930"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_538_14845",
    x1: 23.3335,
    y1: 8.66669,
    x2: 16.0002,
    y2: 8.66669,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C7831F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFB930"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_538_14845",
    x1: 5.3335,
    y1: 12.6667,
    x2: 26.6668,
    y2: 12.6667,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C7831F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFB930"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPromotionActive);
export default __webpack_public_path__ + "static/media/icon_promotion_active.3592036c7998dcba9018858a2a28e2e7.svg";
export { ForwardRef as ReactComponent };